export default {
  player: 'playerBadge',
  roblox: 'robloxBadge'
};
